import React, { useCallback, useState } from 'react'

import { Divider } from '@material-ui/core';

import { Select,TextInput } from '../EditorFormElements'
import { Collapsible, FormFieldWrapper, SortableList } from '../Global';
import { Choice } from '.'

import makePath from '../../utils/makePath';

const formatOptions = [
  {
    value: 'text',
    label: 'Text'
  },
  {
    value: 'image',
    label: 'Image'
  }
];


export const Question = React.memo( ({background, defaultFormat, given={}, index, ...props}) => {

  const path = makePath(props.path,index)

  const [format, setFormat] = useState('');
  const [correctChoice, setCorrectChoice] = useState('');

  const onSelectChange = (name, value) => {
    setFormat(value)
  }

  const onChangeCorrect = useCallback((choiceId,value) => {
    setCorrectChoice(choiceId)
  }, [setCorrectChoice]);
  
  
  return (
    <Collapsible sortableChild title={`Question ${index + 1}`} headerTag="h4">
     
      <FormFieldWrapper>

        {background ? 
          <TextInput 
            label="Question Background Text"
            name="background"
            multiline={true}
            given={given.background}
            rows={3}
            path={path}
            placeholder="Provide any background information needed to answer this question."
            max={282}
          />
        : '' }

        <TextInput 
          label="Question Text"
          name="text"
          multiline
          given={given.text}
          rows={2}
          placeholder="Provide a question for the user to answer."
          path={path}
          max={background ? 95 : 125}
        />

        {defaultFormat ? '' :
          <Select 
            name="format"
            label="Choice Format"
            given={given.format}
            options={formatOptions}
            path={path}
            callback={onSelectChange}
          />
        }

      </FormFieldWrapper>

      { format || defaultFormat ? 
        <>
          <Divider />

          <SortableList
            label="Answer Choice"
            name="choices"
            path={path}
            given={given.choices}
            min={2}
            max={5}
          >
            <Choice
              callback={onChangeCorrect}
              correctChoice={correctChoice}
              format={format || defaultFormat }
              feedbackForAll={props.feedbackForAll}
            />
          </SortableList>
        </>
      : '' }

      {props.deleteBtn}

    </Collapsible>
  )
  
})
